import { ResCallback } from "../ResCallback";

export type BlankMediaUseType =
  | "Manufacturer"
  | "Importer"
  | "ProfessionalUser";

export interface IBlankMediaUseTypeValue {
  value: BlankMediaUseType;
  title: string;
}

export const blankMediaUseTypeValues = (
  res: ResCallback,
): IBlankMediaUseTypeValue[] => {
  return [
    {
      value: "Importer",
      title: res("blankMedia_UseType_Importer"),
    },
    {
      value: "Manufacturer",
      title: res("blankMedia_UseType_Manufacturer"),
    },
    {
      value: "ProfessionalUser",
      title: res("blankMedia_UseType_ProfessionalUser"),
    },
  ];
};
